export { LY_UPLOAD_CONTROL_VALUE_ACCESSOR, LyUploadFiles, LyUploadFilesModule } from './upload-files';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/upload-files/index.js
// module id = 1386
// module chunks = 31